import useEntityStore from "store/entityStore";

export default class CouponModel {
  data = null;

  constructor(data) {
    this.data = this.pruneData(data);
  }

  pruneData(data) {
    let _data = null;

    const entity = useEntityStore.getState().entity;

    if (data) {
      _data = {
        code: data.code,
        applyText: data.apply_text,
        discountText: data.discount_text,
      };

      if(entity.data.payment.plans && entity.data.payment.plans.length > 0){
        _data.plans = {};

        entity.data.payment.plans.forEach((plan) => {
          const discountForThisPlan = data[plan.data.uid];

          if (discountForThisPlan) {
            _data.plans[plan.data.uid] = {
              currency: discountForThisPlan.currency,
              amount_after_discount:
                discountForThisPlan.amount_after_coupon_discount,
            };
          }
        });
      } else {
          _data = {
            ..._data,
            currency: data.currency,
            amount_after_discount: data.amount_after_coupon_discount,
          };
      }
    }

    return _data;
  }

  get data() {
    return this.data;
  }
}
